import { render, staticRenderFns } from "./TableDataSetting.vue?vue&type=template&id=5f7661c3&"
import script from "./TableDataSetting.vue?vue&type=script&lang=js&"
export * from "./TableDataSetting.vue?vue&type=script&lang=js&"
import style0 from "./TableDataSetting.vue?vue&type=style&index=0&id=5f7661c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports